<div class="mt-4 mb-2">
  <h3 class="fw-bold">Configurações</h3>
  <div class="card">
    <div class="card-body">
      <div class="d-flex gap-2">
        <div>
          <svg
            width="24"
            height="16"
            viewBox="0 0 24 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.9921 10.805C11.9973 10.1358 12.7605 9.16085 13.1687 8.02439C13.577 6.88792 13.6087 5.65024 13.2591 4.49437C12.9095 3.3385 12.1973 2.32581 11.2276 1.60605C10.258 0.886294 9.0825 0.497681 7.87492 0.497681C6.66735 0.497681 5.49184 0.886294 4.52221 1.60605C3.55258 2.32581 2.84032 3.3385 2.49076 4.49437C2.1412 5.65024 2.17288 6.88792 2.58114 8.02439C2.9894 9.16085 3.75255 10.1358 4.75774 10.805C2.93945 11.4751 1.38659 12.7152 0.330862 14.3403C0.275377 14.4227 0.236837 14.5154 0.217482 14.6129C0.198127 14.7104 0.198344 14.8108 0.218119 14.9082C0.237895 15.0056 0.276835 15.0981 0.332676 15.1803C0.388516 15.2625 0.460144 15.3328 0.543396 15.3871C0.626647 15.4414 0.719861 15.4787 0.81762 15.4966C0.915378 15.5146 1.01573 15.5129 1.11285 15.4917C1.20996 15.4706 1.3019 15.4303 1.38332 15.3733C1.46473 15.3163 1.53401 15.2437 1.58711 15.1597C2.2681 14.1123 3.19995 13.2516 4.29802 12.6558C5.3961 12.0599 6.62562 11.7479 7.87492 11.7479C9.12423 11.7479 10.3538 12.0599 11.4518 12.6558C12.5499 13.2516 13.4817 14.1123 14.1627 15.1597C14.2727 15.3231 14.4427 15.4368 14.6358 15.476C14.8289 15.5152 15.0297 15.4768 15.1947 15.3692C15.3598 15.2615 15.4758 15.0932 15.5178 14.9007C15.5598 14.7082 15.5243 14.5068 15.419 14.3403C14.3633 12.7152 12.8104 11.4751 10.9921 10.805ZM3.74992 6.12496C3.74992 5.30911 3.99185 4.51159 4.44511 3.83324C4.89837 3.15488 5.54261 2.62617 6.29636 2.31396C7.0501 2.00175 7.8795 1.92006 8.67967 2.07922C9.47984 2.23839 10.2148 2.63126 10.7917 3.20815C11.3686 3.78504 11.7615 4.52004 11.9207 5.32022C12.0798 6.12039 11.9981 6.94979 11.6859 7.70353C11.3737 8.45728 10.845 9.10151 10.1667 9.55477C9.4883 10.008 8.69077 10.25 7.87492 10.25C6.78129 10.2487 5.7328 9.81373 4.95948 9.04041C4.18616 8.26709 3.75117 7.2186 3.74992 6.12496ZM23.4506 15.3781C23.284 15.4867 23.081 15.5247 22.8864 15.4838C22.6918 15.4428 22.5214 15.3262 22.4127 15.1597C21.7326 14.1116 20.8008 13.2506 19.7025 12.655C18.6042 12.0594 17.3743 11.7483 16.1249 11.75C15.926 11.75 15.7352 11.6709 15.5946 11.5303C15.4539 11.3896 15.3749 11.1989 15.3749 11C15.3749 10.8011 15.4539 10.6103 15.5946 10.4696C15.7352 10.329 15.926 10.25 16.1249 10.25C16.7324 10.2494 17.3322 10.1147 17.8816 9.85538C18.431 9.59611 18.9163 9.2187 19.3029 8.75013C19.6895 8.28155 19.9678 7.73337 20.118 7.14475C20.2682 6.55614 20.2865 5.94162 20.1716 5.3451C20.0568 4.74859 19.8116 4.1848 19.4536 3.69402C19.0956 3.20325 18.6337 2.7976 18.1007 2.50606C17.5678 2.21452 16.977 2.04429 16.3707 2.00752C15.7643 1.97076 15.1573 2.06838 14.5931 2.2934C14.501 2.33317 14.402 2.3541 14.3018 2.35495C14.2016 2.35579 14.1022 2.33654 14.0095 2.29833C13.9169 2.26012 13.8328 2.20373 13.7623 2.13248C13.6918 2.06123 13.6363 1.97658 13.5991 1.88352C13.5619 1.79046 13.5437 1.69088 13.5456 1.59067C13.5475 1.49046 13.5695 1.39165 13.6102 1.30007C13.651 1.2085 13.7097 1.12602 13.7828 1.05752C13.856 0.98901 13.9421 0.935862 14.0362 0.901213C15.3275 0.386198 16.7639 0.367665 18.0681 0.849188C19.3723 1.33071 20.452 2.27817 21.0989 3.50879C21.7458 4.73941 21.914 6.16599 21.5711 7.51332C21.2283 8.86066 20.3986 10.0333 19.2421 10.805C21.0604 11.4751 22.6133 12.7152 23.669 14.3403C23.7776 14.5069 23.8156 14.7098 23.7747 14.9044C23.7337 15.099 23.6171 15.2694 23.4506 15.3781Z"
              fill="#3199D0"
            />
          </svg>
        </div>

        <div class="mb-3 w-100">
          <div class="d-flex justify-content-between">
            <div>
              <label class="form-check-label" for="showFollowUp">
                Mostrar Acompanhamento
              </label>
            </div>

            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                id="showFollowUp"
                checked
                [(ngModel)]="showFollowUp"
                (ngModelChange)="setShowFollowUp($event)"
              />
            </div>
          </div>

          <div>
            <small class="text-muted d-block">
              Habilite ou desabilite a visualização total de Serviço de
              Acompanhamento na Proposta de Trabalho desse estudo.
            </small>
          </div>
        </div>
      </div>

      <hr />

      <div class="d-flex gap-2">
        <div>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.75 11.25V20.25C12.75 20.4489 12.671 20.6397 12.5303 20.7803C12.3897 20.921 12.1989 21 12 21C11.8011 21 11.6103 20.921 11.4697 20.7803C11.329 20.6397 11.25 20.4489 11.25 20.25V11.25C11.25 11.0511 11.329 10.8603 11.4697 10.7197C11.6103 10.579 11.8011 10.5 12 10.5C12.1989 10.5 12.3897 10.579 12.5303 10.7197C12.671 10.8603 12.75 11.0511 12.75 11.25ZM18.75 18C18.5511 18 18.3603 18.079 18.2197 18.2197C18.079 18.3603 18 18.5511 18 18.75V20.25C18 20.4489 18.079 20.6397 18.2197 20.7803C18.3603 20.921 18.5511 21 18.75 21C18.9489 21 19.1397 20.921 19.2803 20.7803C19.421 20.6397 19.5 20.4489 19.5 20.25V18.75C19.5 18.5511 19.421 18.3603 19.2803 18.2197C19.1397 18.079 18.9489 18 18.75 18ZM21 15H19.5V3.75C19.5 3.55109 19.421 3.36032 19.2803 3.21967C19.1397 3.07902 18.9489 3 18.75 3C18.5511 3 18.3603 3.07902 18.2197 3.21967C18.079 3.36032 18 3.55109 18 3.75V15H16.5C16.3011 15 16.1103 15.079 15.9697 15.2197C15.829 15.3603 15.75 15.5511 15.75 15.75C15.75 15.9489 15.829 16.1397 15.9697 16.2803C16.1103 16.421 16.3011 16.5 16.5 16.5H21C21.1989 16.5 21.3897 16.421 21.5303 16.2803C21.671 16.1397 21.75 15.9489 21.75 15.75C21.75 15.5511 21.671 15.3603 21.5303 15.2197C21.3897 15.079 21.1989 15 21 15ZM5.25 15C5.05109 15 4.86032 15.079 4.71967 15.2197C4.57902 15.3603 4.5 15.5511 4.5 15.75V20.25C4.5 20.4489 4.57902 20.6397 4.71967 20.7803C4.86032 20.921 5.05109 21 5.25 21C5.44891 21 5.63968 20.921 5.78033 20.7803C5.92098 20.6397 6 20.4489 6 20.25V15.75C6 15.5511 5.92098 15.3603 5.78033 15.2197C5.63968 15.079 5.44891 15 5.25 15ZM7.5 12H6V3.75C6 3.55109 5.92098 3.36032 5.78033 3.21967C5.63968 3.07902 5.44891 3 5.25 3C5.05109 3 4.86032 3.07902 4.71967 3.21967C4.57902 3.36032 4.5 3.55109 4.5 3.75V12H3C2.80109 12 2.61032 12.079 2.46967 12.2197C2.32902 12.3603 2.25 12.5511 2.25 12.75C2.25 12.9489 2.32902 13.1397 2.46967 13.2803C2.61032 13.421 2.80109 13.5 3 13.5H7.5C7.69891 13.5 7.88968 13.421 8.03033 13.2803C8.17098 13.1397 8.25 12.9489 8.25 12.75C8.25 12.5511 8.17098 12.3603 8.03033 12.2197C7.88968 12.079 7.69891 12 7.5 12ZM14.25 7.5H12.75V3.75C12.75 3.55109 12.671 3.36032 12.5303 3.21967C12.3897 3.07902 12.1989 3 12 3C11.8011 3 11.6103 3.07902 11.4697 3.21967C11.329 3.36032 11.25 3.55109 11.25 3.75V7.5H9.75C9.55109 7.5 9.36032 7.57902 9.21967 7.71967C9.07902 7.86032 9 8.05109 9 8.25C9 8.44891 9.07902 8.63968 9.21967 8.78033C9.36032 8.92098 9.55109 9 9.75 9H14.25C14.4489 9 14.6397 8.92098 14.7803 8.78033C14.921 8.63968 15 8.44891 15 8.25C15 8.05109 14.921 7.86032 14.7803 7.71967C14.6397 7.57902 14.4489 7.5 14.25 7.5Z"
              fill="#3199D0"
            />
          </svg>
        </div>

        <div class="d-flex flex-column w-100">
          <div class="d-flex justify-content-between">
            <label class="form-check-label" for="automaticCalculation">
              Cálculo Automático
            </label>

            <div class="form-check form-switch mb-3">
              <input
                class="form-check-input"
                type="checkbox"
                id="automaticCalculation"
                [(ngModel)]="automaticCalculation"
                (ngModelChange)="setAutomaticCalculation($event)"
              />
            </div>
          </div>

          <div>
            <small class="text-muted d-block">
              Percentual sobre Renda Bruta Anual
            </small>

            <div class="row">
              <div class="col-sm-6 col-md-2">
                <div class="input-group mb-3">
                  <input
                    type="number"
                    class="form-control"
                    aria-label="Percentual sobre Renda Bruta Anual"
                    [disabled]="automaticCalculation == false"
                    [(ngModel)]="percentageAutomaticCalculation"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>

              <div class="col-auto">
                <button
                  class="btn btn-outline-secondary"
                  type="button"
                  [disabled]="automaticCalculation == false"
                  (click)="
                    setPercentageAutomaticCalculation(
                      percentageAutomaticCalculation
                    )
                  "
                >
                  Aplicar
                </button>
              </div>
            </div>
          </div>

          <div>
            <small class="text-muted d-block mt-2">
              Por padrão, utilizamos 3% da Renda Bruta Anual (RBA), com um
              mínimo de R$3.000,00 e sem um valor máximo. Ao marcar essa opção
              você fica livre para escolher o percentual sobre a RBA.
              <br />
              Quando habilitada, esta configuração retira a edição dos planos
              abaixo. Sua última edição salva será preservada caso deseje
              desabilitar o Cálculo Automático.
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
